/**
 * What stands in for content that has not arrived. The shared guide asks every load to be a
 * skeleton of what is coming rather than a spinner, so this is one plain ground on a slow
 * pulse, shaped by whoever places it.
 */
export function Skeleton({ className = '' }: { className?: string }) {
  return <span aria-hidden className={`block animate-pulse rounded-2xl bg-hover ${className}`} />
}

/**
 * A skeleton standing in for a whole block of content, so the wait says what is coming rather
 * than saying nothing. Screen readers hear one word instead of the shapes.
 */
export function SkeletonBlock({
  label = 'Loading',
  className = '',
  children,
}: {
  label?: string
  className?: string
  children: React.ReactNode
}) {
  return (
    <div role="status" aria-label={label} className={className}>
      {children}
    </div>
  )
}
